import { Field } from 'redux-form';
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import BaseField from './base';

class RenderTextField extends BaseField {
  render() {
    const { input: inputProps, meta, label, ...rest } = this.props;
    return (
      <div className="input-general">
        {label ? (
          <label className="input-general__label" htmlFor={inputProps.name}>
            {label}
          </label>
        ) : null}
        <input {...inputProps} {...rest} />
        {this.errorMessage()}
        {this.warningMessage()}
      </div>
    );
  }
}

export const TextField = (props) => (
  <Field component={RenderTextField} type="text" {...props} />
);

export default TextField;
